module.exports = __webpack_public_path__ + "files/371878af13115c5ae85d766a0cc35d3f.png";